import { useEffect } from "react";

const STYLE_ID = "mark-highlight-observer-styles";

const css = `
  #cuerpo-de-nota mark {
    background-color: transparent;
    background-image: linear-gradient(var(--extralight-blue), var(--extralight-blue));
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 0% 85%;
    transition: background-size 1.5s ease;
  }
  #cuerpo-de-nota mark.mark--visible {
    background-size: 100% 85%;
  }
`;

export default function MarkHighlightObserver({ selector = "#cuerpo-de-nota mark" }) {
  useEffect(() => {
    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement("style");
      style.id = STYLE_ID;
      style.textContent = css;
      document.head.appendChild(style);
    }

    const marks = document.querySelectorAll(selector);
    if (!marks.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("mark--visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    marks.forEach((mark) => observer.observe(mark));

    return () => observer.disconnect();
  }, [selector]);

  return null;
}
